import React from 'react';
import OurStepManager from "../../common/OurStepManager";
import SelectCondition from './SelectCondition';
import ChooseATime from "./ChooseATime";
import AgreeToTerms from './AgreeToTerms';
import ReviewAndSubmit from './ReviewSubmit';
import VideoVisitConfirmation from './VideoVisitConfirmation';
import { connect } from "react-redux";
import * as types from "../../../constants/actionTypes";
import moment from 'moment-timezone';
import SectionLoadingError from "../../common/SectionLoadingError";
import ConfirmationModal from "../../common/ConfirmationModal";
import { Redirect } from 'react-router-dom';
import { logUI } from "../../../api/andyliticsApi";
import * as Tools from "../../../helpers/Tools";
import * as d from "../../../reducers/domainReducer";


class GetStartedVideoVisit extends React.Component {
    constructor(props) {
        super(props);
        const slotFromVideoAvailabilty = this.props.location && this.props.location.state && this.props.location.state.selectedTimeSlot ? true : false;
        const isFromVideoVisitOptions = this.props.location && this.props.location.state && this.props.location.state.isFromVideoVisitOptions ? true : false;
        this.state = {
            startAtStep: 0,
            currentStep: 0,
            isSubmitted: false,
            videoVisitRequest: {},
            slotFromVideoAvailabilty,
            isFromVideoVisitOptions
        };
        this.baseURL = window.location.pathname;
        this.stepManagerRef = React.createRef();
    }
    componentDidMount() {
        this.props.getVideoVisitConditions();
        if (this.state.slotFromVideoAvailabilty) { //update the local state if video schedule time selected on landing page.
            const selectedTime = this.props.location && this.props.location.state && this.props.location.state.selectedTimeSlot;
            const selectedDay = this.props.location && this.props.location.state && this.props.location.state.selectedDay;
            this.onTimeSelectionChange(selectedTime, selectedDay);
        }

        logUI("MBHWeb.UI.VideoVisit.GetStarted.ComponentDidMount", new Date(), Tools.getURLPath());
    }
    blockNavigation(nextLocation) {
        const re = /^\/schedulevideovisit/;
        return nextLocation !== null && re.test(nextLocation.pathname);
    }
    onUserSwitched = (userSelected, index) => {
        window.userToSwitch = userSelected;
        this.setState({ userSelected });
    }
    callbackOnLeave = () => {
        const { serverData } = this.props;
        const enabledVirtualDashboard = serverData && serverData.enableVirtualDashboardUpdates ? serverData.enableVirtualDashboardUpdates : false;
        if (enabledVirtualDashboard) {
            this.props.history.push("/videovisitoptions");
        } else {
            this.props.history.push("/videoondemand");
        }
    }
    onStepChange = (success, step) => {
        if (typeof window !== 'undefined' && success) {
            window.scrollTo(0, 0);
        }
        if (success) {
            this.setState({ currentStep: step });
        }

    }
    onConditionSelectionChange = (condition, conditionId) => {
        this.setState({
            videoVisitRequest: {
                ...this.state.videoVisitRequest,
                condition,
                conditionId
            }
        });

    }
    onTimeSelectionChange = (timeSlot, day) => {
        this.setState({
            videoVisitRequest: {
                ...this.state.videoVisitRequest,
                timeSlot,
                day
            }
        });
    }
    onSubmit = () => {
        const { userDetails, serverData, currentUser } = this.props;
        const { videoVisitRequest } = this.state;

        const externalPatientId = currentUser && currentUser.ei ? currentUser.ei : null;
        const visitDate = moment(videoVisitRequest.timeSlot.dateTimeInDallas).format('YYYY-MM-DD');
        const visitTime = moment(videoVisitRequest.timeSlot.dateTimeInDallas).format('HH:mm:ss');
        const patientName = currentUser && currentUser.dn ? currentUser.dn : "";
        const videoVisitConfirmationData = {
            visitDateTime: videoVisitRequest.timeSlot.dateTimeInUtc,
            visitDay: videoVisitRequest.day,
            patientName
        };
        this.setState({ isSubmitted: true, videoVisitConfirmationData });
        const { visitTypeId, visitTypeIdType, departmentId, departmentIdType } = videoVisitRequest.timeSlot;
        const requestData = {
            LoginId: userDetails.userName,
            MyChartId: userDetails.MyChartID,
            ProxyPatientId: externalPatientId,
            ProxyPatientIdType: "External",
            VisitTypeId: visitTypeId,
            VisitTypeIdType: visitTypeIdType,
            ProviderId: serverData.providerId,
            ProviderIdType: "External",
            DepartmentId: departmentId,
            DepartmentIdType: departmentIdType,
            Date: visitDate,
            Time: visitTime,
            Duration: "15",
            Comments: videoVisitRequest.condition,
            Condition: videoVisitRequest.condition,
            PatientName: patientName,
            EmailAddress: userDetails.Email,
            ConditionId: videoVisitRequest.conditionId
        };
        this.props.scheduleVideoVisitRequest(requestData);
        logUI("MBHWeb.UI.VideoVisit.Submit", new Date(), Tools.getURLPath(), JSON.stringify(requestData));
    }

    acceptTerms = (versionId) => {
        const { acceptTerms, currentUser } = this.props;
        const proxyId = currentUser && currentUser.ei ? currentUser.ei : null;
        acceptTerms({ versionId, proxyId });
        logUI("MBHWeb.UI.VideoVisit.AgreeToTerms.AcceptTerms", new Date(), Tools.getURLPath());
    }
    retryVideoVisitRequest = (key) => {
        // if (key === "reset")
        //    this.props.history.push("/videovisitdetails");
        //else 
        logUI("MBHWeb.UI.VideoVisit.RetryScheduleRequest", new Date(), Tools.getURLPath());
        this.setState({ isSubmitted: false, startAtStep: 0 });

        if (this.state.isFromVideoVisitOptions) {
            this.props.history.push("/videovisitoptions");
        }

    }
    render() {
        const { isSubmitted, videoVisitRequest, videoVisitConfirmationData, currentStep, slotFromVideoAvailabilty } = this.state;
        const { videoVisit, videoVisitConditions, isProxyUser, serverData, technicalHelpDeskHours, technicalHelpDeskNumber, showTimeZoneMessage } = this.props;
        const { isError, isSuccess } = videoVisitConditions;

        const enabledVirtualDashboard = serverData && serverData.enableVirtualDashboardUpdates ? serverData.enableVirtualDashboardUpdates : false;
        const timezone = showTimeZoneMessage && !Tools.isCentralTimeZone() ? Tools.getCentralDateWithFormat(new Date(), "z") : "";

        return (
            (isProxyUser && !enabledVirtualDashboard) ? <Redirect to="/videoondemand" /> : <div className="container-fluid body-content get-started-container">
                <div className="row">
                    <React.Fragment>
                        {!isSubmitted
                            ? <React.Fragment>
                                {!isError ?
                                    <div className="col-12">
                                        <div className="row">
                                            <div className="col-12 progtrckr-divider" />
                                            <div className="col-12">
                                                <div className="step-progress maxWidth-content">
                                                    <OurStepManager ref={this.stepManagerRef} baseURL={this.baseURL}
                                                        backButtonCls='hidden' startingStep={this.state.startAtStep ? this.state.startAtStep : 0} onStepChange={this.onStepChange}
                                                    >
                                                        {!slotFromVideoAvailabilty && enabledVirtualDashboard && <ChooseATime steptitle='Choose A Time' shouldHideContinueButton onTimeSelectionChange={this.onTimeSelectionChange} enabledVirtualDashboard={enabledVirtualDashboard} timezone={timezone} showTimeZoneMessage={showTimeZoneMessage} />}
                                                        <SelectCondition steptitle='Select Condition' shouldHideContinueButton onConditionSelectionChange={this.onConditionSelectionChange} videoVisitRequest={videoVisitRequest} enabledVirtualDashboard={enabledVirtualDashboard} timezone={timezone} showTimeZoneMessage={showTimeZoneMessage}/>
                                                        {!slotFromVideoAvailabilty && !enabledVirtualDashboard && <ChooseATime steptitle='Choose A Time' shouldHideContinueButton onTimeSelectionChange={this.onTimeSelectionChange} timezone={timezone} showTimeZoneMessage={showTimeZoneMessage}/>}
                                                        {/*<AgreeToTerms steptitle='Agree To Terms' shouldHideContinueButton acceptTerms={this.acceptTerms} />*/}
                                                        <ReviewAndSubmit steptitle='Review & Submit' continueButtonText="SCHEDULE IT!" onSubmit={this.onSubmit} videoVisitRequest={videoVisitRequest} timezone={timezone} showTimeZoneMessage={showTimeZoneMessage}/>
                                                    </OurStepManager>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    : <div className="col-12 maxWidth-content">
                                        <div className="row"><div className="col-12"><h1 className="page-heading">Video Visit</h1></div></div>
                                        <SectionLoadingError message="We are currently not able to schedule appointments. Please try again later." />
                                        {/* <div className="col-12 try-again top-margin">Please <input type="submit" className="btn text-btn" value="try again" onClick={() => this.retryVideoVisitRequest("reset")} />.</div> */}
                                    </div>
                                }
                            </React.Fragment>
                            : <div className="col-12"><VideoVisitConfirmation videoVisit={videoVisit} videoVisitConfirmationData={videoVisitConfirmationData} retryVideoVisitRequest={this.retryVideoVisitRequest} technicalHelpDeskHours={technicalHelpDeskHours} technicalHelpDeskNumber={technicalHelpDeskNumber} timezone={timezone} showTimeZoneMessage={showTimeZoneMessage} /></div>
                        }
                    </React.Fragment>
                    {!isSubmitted && (window.formChanged || currentStep > 0) &&
                        <ConfirmationModal when={!isSuccess || !isError} noReload blockNavigation={this.blockNavigation} callbackOnLeave={this.callbackOnLeave} switchToMyChartUser={this.onUserSwitched} />
                    }
                </div>
            </div>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        userDetails: state.sso.userDetails,
        serverData: state.session.serverData,
        technicalHelpDeskNumber: state.session.serverData ? state.session.serverData.technicalHelpDeskNumber:"",
        technicalHelpDeskHours: state.session.serverData ? state.session.serverData.technicalHelpDeskHours : "",
        showTimeZoneMessage: state.session.serverData ? state.session.serverData.showTimeZoneMessage : false,
        videoVisit: state.videoVisitScheduling.videoVisit,
        currentUser: state.domain.cu,
        videoVisitConditions: state.videoVisitScheduling.videoVisitConditions ? state.videoVisitScheduling.videoVisitConditions : {},
        isProxyUser: state.domain.ip
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        getVideoVisitConditions: () => dispatch({ type: types.GET_VIDEO_VISIT_CONDITIONS }),
        scheduleVideoVisitRequest: (requestData) => dispatch({ type: types.SCHEDULE_VIDEO_VISIT_REQUEST, data: requestData }),
        acceptTerms: data => dispatch({ type: types.ACCEPT_VIDEO_VISIT_CONDITIONS, data })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(GetStartedVideoVisit);